<template>
  <div ref="el"></div>
</template>

<style scoped>
</style>

<script>
import Highcharts from 'highcharts'
import moment from 'moment'

moment.locale('en')

export default {
  props: {
    selected: {
      type: String,
      required: false,
      default: () => ('')
    },
    options: {
      type: Object,
      required: true,
      default: () => ({})
    },
    series: {
      type: Array,
      required: true,
      default: () => ([])
    }
  },

  methods: {
    renderChart: function () {
      var opts = this.options
      opts.chart.renderTo = this.$refs.el // s.chart
      opts.series = this.series

      // console.log('time-series-chart ready', this, this.series, opts)
      // this.options.chart = this.optionsChart

      // console.log('time-series-chart ready', this.options)
      this.chart = new Highcharts.Chart(opts)
    },
    updateChart: function () {
      this.chart.series = this.series
      this.chart.redraw()
    }
  },

  mounted () {
    this.renderChart()
  },

  data () {
    return {
      chart: null
    }
  },

  watch: {
    series: function (val) {
      // console.log('time-series-chart watch series', val, this.series, this.chart.series.length)
      this.$nextTick(function () {
        this.renderChart()
      })

      /*
      this.$nextTick(function () {
        // TODO update chart series instead of creating new chart
        this.chart.series = this.series
        this.chart.redraw()
      })
      */
    }
  }
}

</script>



// WEBPACK FOOTER //
// HighChart.vue?f79df954